import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21059 21055"
    {...props}
  >
    <defs>
      {/* <style>{".str1{stroke:#000;stroke-width:213.8}.fil1{fill:#000}"}</style> */}
    </defs>
    <g>
      <g id="_1974326553328">
        <path
          d="m11361 20069 129-12h1c2185-221 4229-1193 5784-2750 3725-3733 3725-9785 0-13518C13550 57 7509 57 3784 3789 59 7522 59 13574 3784 17307 59 13574 59 7522 3784 3789m6348 11324c171 1561-698 4975 1359 4944"
          style={{
            fill: "none",
            fillRule: "nonzero",
            stroke: "#000",
            strokeWidth: 1979.47,
          }}
          className="stroke1"
        />
        <path
          d="M6349 8860h8031v3527c0 1624-1326 2952-2947 2952H9122c-1525 0-2773-1250-2773-2779V8860zM7215 8002h1467V5188c0-369-300-670-668-670h-170c-346 0-629 284-629 630v2854zM12046 8002h1467V5188c0-369-301-670-668-670h-170c-346 0-629 284-629 630v2854z"
          className="fil1"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
